import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import UniversalTable from "../../components/organization/table/UniTable";
import CreateUserForm from "../../components/loginform/CreateUserForm";
import PageHeader from "../../components/header/pageheader/PageHeader";
import Modal from "../../components/forms/wrap/Modal";
import "./styles.css";

interface User {
  id: number;
  email: string;
  tel: string;
  password?: string;
  roleId: number;
  companyId: number;
  plantId: number | null;
}

export default observer(function Users() {
  const { store } = useContext(Context);

  const [isvisible, setvisible] = useState(false);
  const [editingUser, setEditingUser] = useState<User | null>(null);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    store.fetchUsers();
  };

  const handleEdit = (user: User) => {
    // `АУД-Н156`: запись пользователя в консоль не пишем — это персональные данные.
    setEditingUser(user);
    setvisible(true);
  };

  const users = store.users;
  const itemsToDisplay = users;

  return (
    <>
      <div className="all_station_container">
        <PageHeader
          title="ПОЛЬЗОВАТЕЛИ"
          buttontext="Создать пользователя"
          onCreate={() => {
            setEditingUser(null);
            setvisible(true);
          }}
        />

        <UniversalTable data={itemsToDisplay} type="users" Edit={handleEdit} />
      </div>

      <Modal
        isOpen={isvisible}
        onClose={() => {
          setvisible(false);
          setEditingUser(null);
        }}
      >
        <CreateUserForm
          close={() => {
            setvisible(false);
            setEditingUser(null);
          }}
          user={editingUser}
        />
      </Modal>
    </>
  );
});
